<app-page-header
  [title]="'Administrador de Países y Ciudades'"
  [subtitle]="
    'Podrás gestionar los países y ciudades que se asignen a un Empleado'
  "
></app-page-header>

<app-page-acciones
  [buttonText]="'Nuevo país'"
  [buttonIcon]="'pi pi-plus'"
  [buttonColor]="'#E45F23'"
  (buttonClick)="onNewRegisterCountry()"
  [hasButtonSecond]="false"
  [hasCombo]="false"
  [hasYearOptions]="false"
  [searchQuery]="searchTerm"
  (searchQueryChange)="onSearch($event)"
></app-page-acciones>

<app-list-card
  [items]="countriesData"
  titleField="countryName"
  sublistField="cities"
  subitemField="cityName"
  [isLoading]="isLoading"
  (addClicked)="onNewRegisterCity($event)"
  (editClicked)="onEditCountry($event)"
  (subitemEditClicked)="onEditCity($event)"
></app-list-card>

<div class="country-register-modal">
  <app-country-register-modal
    [(visible)]="showRegisterModal"
    (visibleChange)="onDialogClose()"
    (registerComplete)="onRegisterComplete()"
  >
  </app-country-register-modal>
</div>

<div class="country-edit-modal">
  <app-country-edit-modal
    [(visible)]="showEditModal"
    [countryId]="selectedCountryId"
    (visibleChange)="onDialogClose()"
    (registerComplete)="onEditComplete()"
  >
  </app-country-edit-modal>
</div>

<div class="city-register-modal">
  <app-city-register-modal
    [(visible)]="showRegisterCityModal"
    [countryId]="selectedCountryId"
    (visibleChange)="onDialogCityClose()"
    (registerCityComplete)="onRegisterCityComplete()"
  >
  </app-city-register-modal>
</div>

<div class="city-edit-modal">
  <app-city-edit-modal
    [(visible)]="showEditCityModal"
    [countryId]="selectedCountryId"
    [cityId]="selectedCityId"
    (visibleChange)="onDialogCityClose()"
    (editCityComplete)="onEditCityComplete()"
  >
  </app-city-edit-modal>
</div>
